<div class="auth-container">
  <div class="auth-card">
    <div class="auth-header">
      <img src="opscribe_logo3.png" alt="Opscribe Logo" class="auth-logo">
      <h2>Welcome Back</h2>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="email">Email</label>
        <input id="email" type="email" formControlName="email" placeholder="Enter your email"
          [class.invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input id="password" type="password" formControlName="password" placeholder="Enter your password"
          [class.invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
      </div>

      <div class="form-actions">
        <a routerLink="/forgot-password" class="forgot-link">Forgot password?</a>
      </div>

      <button type="submit" class="btn-primary">
        <span *ngIf="!isLoading">Sign In</span>
        <span *ngIf="isLoading">Signing In...</span>
      </button>

      <div *ngIf="errorMessage" class="error-alert">
        {{ errorMessage }}
      </div>
    </form>

    <div class="auth-footer">
      <p>Don't have an account? <a routerLink="/register">Sign up</a></p>
    </div>
  </div>
</div>